import React, { useEffect } from 'react';
import { useHubConnection, useDisconnectHub } from 'CustomHooks/useHubConnection';
import { IStyle } from 'Styles';
import { JobTypeDTO } from 'components/main/Setup/Imaging/ImageManagementTask/constants';
import NewProgressBar from 'components/main/Setup/Imaging/ImageManagementTask/Results/NewProgressBar';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import { useRMDispatch } from 'redux/hooks';
import {
  addBackgroundJob,
  setBackgroundJobs,
  updateBackgroundJobProgress,
} from 'redux/reducers/backgroundJobsReducer';
import { useGetBackgroundJobs } from 'redux/hooks/backgroundJobs';

export interface BackgroundJobDTO {
  jobId: number;
  jobType: number;
  name: string;
  progress: number;
  logs: any[];
  dataObj: any;
}

const BackgroundJobs = () => {
  const connection = useHubConnection();
  const disconnectHub = useDisconnectHub();
  const backgroundJobs = useGetBackgroundJobs();
  const dispatch = useRMDispatch();

  useEffect(() => {
    connection.start().then(() => {
      connection
        .invoke('RequestJobsByType', JobTypeDTO.ImageManangement)
        .catch((error) => {
          console.error("Failed invoke 'RequestJobsByType',", error);
        });

      const handleAddNewJob = (data) => {
        if (data && data.jobType === JobTypeDTO.ImageManangement) {
          dispatch(addBackgroundJob(data));
        }
      };

      const handleUpdateJobProgress = (data) => {
        if (data && data.jobType === JobTypeDTO.ImageManangement) {
          dispatch(
            updateBackgroundJobProgress({
              jobId: data.jobId,
              progress: data.progress,
              name: data.name,
            }),
          );
        }
      };
      connection.on('UpdateJobProgress', handleUpdateJobProgress);

      connection.on('AddNewJob', handleAddNewJob);

      connection.on('ReceiveJobsByType', (data) => {
        dispatch(
          setBackgroundJobs(
            data.filter(
              (item) =>
                item.progress !== 100 && item.jobType == JobTypeDTO.ImageManangement,
            ),
          ),
        );
      });
    });

    return () => {
      disconnectHub(connection);
    };
  }, []);

  return (
    <div id="background-jobs-wrapper">
      {backgroundJobs?.map((job) => (
        <div
          id="background-jobs-root"
          key={`background-job-${job.jobId}`}
          style={styles.cardRoot}
        >
          <div
            id="background-jobs-icon"
            style={styles.progress}
            className="flex flex-row justify-around"
          >
            <RMSvgIcon
              id="background-jobs-icon-image-management-task"
              onClick={() => {}}
              name="ImageManagementTask"
              width={25}
              height={25}
            />
            <NewProgressBar
              mainContainerClassName="flex flex-column w-[85%]"
              title={job.name}
              progressBarContainerClass="w-[100%] taskProgress"
              currentProgress={job.progress}
              progressWidth={job.progress}
              progressContainerStyle={styles.progressBar}
              showProgressDigits={false}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default BackgroundJobs;
const styles: IStyle = {
  taskRow: {
    display: 'flex',
    flex: '100%',
  },
  taskTitle: {
    color: 'black',
  },
  cardRoot: {
    padding: '1.5%',
  },
  status: {
    fontSize: 'smaller',
    color: 'black',
  },
  progress: {
    fontSize: 'smaller',
    color: 'black',
    height: '1px !important',
  },
  clear: {
    marginTop: '1%',
  },
};
